import { useEffect, useRef, useState } from 'react';
import ContactModal from './ContactModal';

const CTA = () => {
  const sectionRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animated');
            entry.target.classList.remove('animated-out');
          } else {
            entry.target.classList.remove('animated');
            entry.target.classList.add('animated-out');
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <section className="py-12 sm:py-20 px-3 sm:px-4">
        <div className="mx-auto max-w-5xl">
          <div
            ref={sectionRef}
            className="glass-panel relative overflow-hidden rounded-2xl sm:rounded-[3rem] px-4 sm:px-6 md:px-20 py-12 sm:py-20 md:py-24 text-center animate-on-scroll"
          >
            {/* Glow effect behind - simplified */}
            <div className="absolute left-1/2 top-1/2 -z-10 h-48 w-48 sm:h-64 sm:w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/15 blur-[80px]"></div>
            <h2 className="mb-4 sm:mb-6 text-2xl sm:text-4xl md:text-6xl font-black text-white">Ready to command the AI?</h2>
            <p className="mb-6 sm:mb-10 text-sm sm:text-lg text-white/70 px-2">Join 50,000+ creators building the future of digital art.</p>
            <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
              <button
                onClick={() => setIsModalOpen(true)}
                className="btn-glow flex h-12 sm:h-14 min-w-[160px] sm:min-w-[200px] items-center justify-center rounded-full bg-primary px-6 sm:px-8 text-sm sm:text-base font-bold text-background-dark"
              >
                Get started
              </button>
            </div>
          </div>
        </div>
      </section>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default CTA;
